import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SaveIcon from 'material-ui/svg-icons/content/save';
import UndoIcon from 'material-ui/svg-icons/content/undo';
import qs from 'query-string';
import { Dialog, RaisedButton, IconButton, MenuItem, TextField } from 'material-ui';
import update from 'immutability-helper';
import EmojiPicker from './pickers/EmojiPicker';
import _ from 'lodash';
import RCore from 'RCore';
import { getEntities } from 'dash-front/selectors';
import { updatePostMessage, updatePost } from 'dash-front/campaign/actions/posts';
import styled from 'styled-components';
import { approveWithPagination } from 'dash-front/campaign/actions/withPagination';
import { responseStatusIsOk } from 'dash-front/helpers';
import Feature from 'dash-front/hoc/withFeature';
import { FactList } from 'dash-front/campaign/containers/Posts/PostFacts';
import WDPContext from '../../../../../widgets/components/core/WDPContext';
import { WidgetParams } from 'dash-front/components/sm/SMPostDialog.js';

const PropControls = styled.div`
    .pickers-wrapper {
        display: flex;
        justify-content: space-between;
    }
    .preview-image-picker {
        width: 48%;
        > img {
            height: auto;
            width: 100%;
        }
    }
`;

function cancellable(func) {
    var cancelled = false;

    var cancellabled = function() {
        if (!cancelled) {
            func(...arguments);
        }
    };

    cancellabled.cancel = function() {
        cancelled = true;
        if (typeof func.onCancel === 'function') {
            func.onCancel();
        }
    };

    return cancellabled;
}

class EditDialog extends React.PureComponent {
    componentWillReceiveProps = nextProps => {
        if (_.get(nextProps, 'post.presentation.name') !== _.get(this, 'props.post.presentation.name')) {
            this.loadWidget(_.get(nextProps, 'post.presentation.name'));
        }
        if (!nextProps.postId) {
            this.resetChanges();
        }
    };
    state = {
        newParams: {},
        title: null
    };

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    resetChanges = () => {
        this.setState({ newParams: {}, title: null });
    };

    handleSave = () => {
        const { postId } = this.props;
        let changedParams = { ...this.state.newParams };
        if (this.state.title !== undefined) {
            changedParams.title = this.state.title;
        }
        this.props.updatePost(postId, changedParams);
        this.props.close();
        this.resetChanges();
    };

    loadWidget = wid => {
        this.widgetRequestCallback = cancellable(() => {
            this.setState({
                [wid]: true
            });
        });

        if (wid && !this.state[wid]) {
            window.wdpload(wid, {}, {}, this.widgetRequestCallback);
        }
    };

    renderWidget() {
        const { post } = this.props;
        var { accessToken } = this.context.user;
        let theme = {};
        let template = {};
        let wid = post.presentation.name;
        let CMP = _.get(window, `[rlz${wid}][${wid}]`);
        if (!CMP) return;
        let { mergedParams } = post.content.meta;
        if (mergedParams.tournamentId) {
            mergedParams.tournamentId = +mergedParams.tournamentId;
        }

        mergedParams = _.merge({}, mergedParams, this.state.newParams);
        if (this.state.title !== undefined) {
            mergedParams.title = this.state.title;
        }
        return (
            <div>
                <div style={{ textAlign: 'center' }}>
                    <WDPContext token={accessToken} key={wid} social {...mergedParams}>
                        <CMP
                            name={wid}
                            social
                            tempTemplate={_.extend({}, template, { theme })}
                            token={accessToken}
                            {...mergedParams}
                        />
                    </WDPContext>
                </div>
            </div>
        );
    }
    renderControls = () => {
        let { mergedParams } = this.props.post.content.meta;
        let wid = this.props.post.presentation.name;
        let widget = _.get(window, `[rlz${wid}][${wid}]`);
        if (mergedParams.tournamentId) mergedParams.tournamentId = +mergedParams.tournamentId;
        if (!widget) return null;
        return (
            <div>
                <TextField
                    floatingLabelText={'Title'}
                    style={{ width: 600 }}
                    value={this.state.title || mergedParams.title}
                    onChange={(event, title) => {
                        this.setState({ title });
                    }}
                />
                <PropControls>
                    <WidgetParams
                        widget={widget}
                        backgroundOnly
                        jsprops={mergedParams}
                        onChange={this.handlePropChange}
                        onPropChange={this.handlePropChange}
                    />
                </PropControls>
            </div>
        );
    };

    handlePropChange = (prop, val) => {
        let changedProp;
        if (typeof prop === 'object') {
            changedProp = prop;
        } else {
            changedProp = {};
            changedProp[prop] = val;
        }

        var upd = update(this.state, {
            newParams: {
                $merge: changedProp
            }
        });
        upd.newParams = _.omit(upd.newParams);
        this.setState(upd, () => {
            // if (this.onPropsChange) this.onPropsChange();
        });
    };

    // onPropsChange = () => {
    //     // let location = this.props.location;
    //     console.log('this.props.router', this.props.router);
    //     const query = qs.stringify(RCore.prepareWidgetPropsObj(this.state.newProps));
    //     console.log('dasdadad', query);
    //     return;
    //     window.history.pushState({}, '', location.pathname + '?' + query);
    // }

    renderContent() {
        const { post } = this.props;
        if (!post) {
            return null;
        }
        return (
            <div>
                {this.renderControls()}
                {this.renderWidget()}
                <RaisedButton
                    primary
                    label={'Save and generate'}
                    style={{ marginTop: 12 }}
                    onTouchTap={this.handleSave}
                    icon={<SaveIcon />}
                />
            </div>
        );
    }

    render() {
        const { postId, close } = this.props;
        const open = Boolean(postId);
        return (
            <Dialog
                open={open}
                className={'no-padding-dialog'}
                contentStyle={{
                    width: '90%',
                    maxWidth: 863
                }}
                autoScrollBodyContent
                repositionOnUpdate
                autoDetectWindowHeight
                modal={false}
                title={'Edit post and regenerate'}
                onRequestClose={close}
            >
                {this.renderContent()}
            </Dialog>
        );
    }
}

EditDialog.propTypes = {
    postId: PropTypes.string,
    post: PropTypes.object,
    close: PropTypes.func,
    updatePost: PropTypes.func,
    approvePost: PropTypes.func,
    publish: PropTypes.func
};

export default connect(
    (state, { postId }) => ({
        post: _.get(getEntities(state), ['posts', postId])
    }),
    (dispatch, { campaignId }) => ({
        updatePost: (postId, updates) => dispatch(updatePost(postId)(updates)),
        approvePost: postId => dispatch(approveWithPagination(postId))
    })
)(EditDialog);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/EditDialog.js
 **/